import ChatTabs from './chat-tabs';

export default ChatTabs;
